<t4-header icon="glyphicon-stats" title="{{'Turbo.Bookings.Dashboard.Headline' |translate : 'Dashboard' }}">
  <!-- <button mat-button color="primary" matTooltip="{{ 'Turbo.Bookings.Calendar.cmdFindBooking' | translate:'Find booking'}}" (click)="findBooking()"><mat-icon>search</mat-icon><span>{{ 'Turbo.Bookings.Calendar.cmdFindBooking' | translate:'Find booking'}}</span></button> -->
</t4-header>
  <t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
  <t4-dashboard>

    <div class="col-md-6">
      <t4-chart [diagramIds]="[['CA_CampaignBookingActivity', 'y-axis-0'], ['BO_PickupActivity', 'y-axis-0']]" title="{{'Turbo.CampaignBookings.Dashboard.Activity' | translate : 'Campaign Booking Activity' }}" type="line" [fromDate]="fromDate" [toDate]="toDate" unit="week"></t4-chart>
    </div>

    <div class="col-md-3">
      <t4-kpi kpiId="CA_TotalValue" title="{{'TO.Campaigns.Dashboard.CampaignTotalValue' | translate : 'Total discount' }}" type="currency" [fromDate]="fromDate" [toDate]="toDate"></t4-kpi>
    </div>

      <div class="col-md-3">
        <t4-kpi kpiId="CA_DiscountPercentage" title="{{'Turbo.Bookings.Dashboard.Campignbookingprocent' | translate : 'Campaign booking percentage' }}" type="chart" [fromDate]="fromDate" [toDate]="toDate" label1="{{'Turbo.OneWay.Dashboard.CampaignBookingPercentage' | translate : 'Campaign booking' }}" label2="{{'Turbo.OneWay.Dashboard.Campaign_BookingPercentage' | translate : 'Booking' }}"></t4-kpi>
      </div>
    
  </t4-dashboard>
